'use client'

import Carousel from '../common/carousel/Carousel'
import type { Seller } from './getSellerSpotlightData'
import SellerSpotlightCard from './SellerSpotlightCard'
import * as Styled from './ui'

/**
 * Maps sellers to cards on the client side of the server/client boundary.
 *
 * Doing the `.map` here rather than in the server component above it matters:
 * each `SellerSpotlightCard` is itself a Client Component, so building the
 * array in a Server Component means every card crosses the RSC boundary as
 * its own flight row. With ten sellers that produced a real bug — the
 * initial HTML only ever contained the first card, while the flight payload
 * carried all ten, so hydration flagged a mismatch and inserted the other
 * nine. Taking one plain `sellers` array across the boundary and mapping it
 * here, client-side, removes the per-card boundary crossing entirely.
 */
export default function SellerSpotlightCards({
  sellers,
}: {
  sellers: Seller[]
}) {
  return (
    <Carousel>
      {sellers.map((seller) => (
        <SellerSpotlightCard key={seller.name} seller={seller}>
          <Styled.SellerLogo
            src={seller.logo}
            alt={`${seller.name} logo`}
            width={200}
            height={50}
          />
          <Styled.CardTitle>{seller.name}</Styled.CardTitle>
        </SellerSpotlightCard>
      ))}
    </Carousel>
  )
}
